module.exports = __webpack_public_path__ + "static/img/2808_phase_function_Paper_Points.200ff23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2808_phase_function_Paper_Points.png
// module id = iXUg
// module chunks = 0